import { FC, useEffect, useState } from 'react';
import { BREAKPOINTS } from '@belong/themes';
import { ChoiceChipset, Column, Columns, PictureContainer, Section, Stack } from '@belong/ui-components';
import { ISectionCategoryFilter } from './model';
import { ImageWrapper } from './styles';

export const TEST_ID = {
  SECTION: 'section-category-filter'
};

const DESKTOP_BREAKPOINT = 'md';

const CategoryFilter: FC<ISectionCategoryFilter & { isDesktopView: boolean }> = ({
  id,
  isDesktopView,
  filterOptionLabel,
  identifier,
  image,
  onChange,
  options = [],
  selectedValue,
  ...sectionProps
}) => (
  <Section
    data-contentid={id}
    data-identifier={identifier}
    {...sectionProps}
    hasPaddingTop
    hasBackground="white"
    data-testid={TEST_ID.SECTION}
  >
    <Columns alignX="center">
      <Column width={{ md: '5/6', lg: '2/3', xl: '1/2' }}>
        <Stack space="small">
          {isDesktopView && (
            <Stack alignX="center">
              {image && (
                <ImageWrapper contentType={image.contentType}>
                  <PictureContainer {...image} src={[image.src, { fit: 'fill' }]} />
                </ImageWrapper>
              )}
            </Stack>
          )}
          <ChoiceChipset
            name="filter"
            options={options}
            selectedValue={selectedValue}
            onChange={onChange}
            legend={filterOptionLabel}
          />
        </Stack>
      </Column>
    </Columns>
  </Section>
);

const SectionCategoryFilter: FC<ISectionCategoryFilter> = viewProps => {
  const [isDesktopView, setIsDesktopView] = useState<boolean | null>(null);
  const handleBreakpointChange = (event: MediaQueryListEvent) => {
    setIsDesktopView(event.matches);
  };

  useEffect(() => {
    const media = window.matchMedia(`(min-width: ${BREAKPOINTS[DESKTOP_BREAKPOINT] / 16}em)`);
    setIsDesktopView(media.matches);
    media.addListener(handleBreakpointChange);

    return (): void => {
      media.removeListener(handleBreakpointChange);
    };
  }, []);

  // don't render until we know which view is appropriate
  if (isDesktopView === null) {
    return null;
  }

  return <CategoryFilter {...viewProps} isDesktopView={isDesktopView} />;
};

export default SectionCategoryFilter;
